import { textVariantsEnum, fontWeightEnum } from '@/components/Text';
export const paidLeaveTypeList = [
  'Planned Leave',
  'Sick Leave',
  'Casual Leave',
];
export const paidLeaveTypeOptions = [
  {
    label: 'Planned Leave',
    value: 'Planned Leave',
  },
  {
    label: 'Sick Leave',
    value: 'Sick Leave',
  },
  {
    label: 'Casual Leave',
    value: 'Casual Leave',
  },
];
export const paidLeaveOption = {
  label: 'Paid Leave',
  value: 'Paid Leave',
};
export const unpaidLeaveOption = {
  label: 'Unpaid Leave',
  value: 'Unpaid Leave',
};
export const leaveTypeOptions = [
  {
    ...paidLeaveOption,
  },
  {
    ...unpaidLeaveOption,
  },
];

export const leaveBalanceData = [
  {
    label: 'Total Allocated Leaves',
    key: 'totalAllocatedLeaves',
  },
  {
    label: 'Used Leaves',
    key: 'usedLeaves',
  },
  {
    label: 'Available Leaves',
    key: 'availableLeaves',
  },
  {
    label: 'Pending Requests',
    key: 'pendingRequests',
  },
];

export const commonDateLabelTextProps = {
  variant: textVariantsEnum.Text_13,
  fontWeight: fontWeightEnum.Normal,
};
